import React from 'react';
import { Grid, Card, CardMedia, Tooltip } from '@material-ui/core';
import { withTheme } from '@material-ui/styles';
import { formatMoney } from '../utils';
import { TimesIcon } from '../icons';

function ActivityCardForCompare({ activity, minRetailPrice, theme, onClick, onRemove }) {
    return (
        <Grid item xs={3}>
            <Card
                elevation={1}
                rounded="true"
                style={{
                    position: 'relative'
                }}
            >
                <CardMedia
                    style={{ cursor: 'pointer', position: 'relative', height: '130px' }}
                    image={activity.image}
                    onClick={onClick}
                >
                    <div
                        style={{ padding: '4px 4px 4px 4px', background: 'rgba(255,255,255,0.9)' }}
                    >
                        <h5
                            style={{
                                color: '#333',
                                marginBottom: 0,
                                marginRight: 26,
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden'
                            }}
                        >
                            {activity?.company?.name} (
                            {activity?.island?.name === 'Hawaiʻi'
                                ? `${activity?.island?.name} island`
                                : activity?.island?.name}
                            )
                        </h5>
                        <Tooltip title="Remove" placement="bottom-end">
                            <TimesIcon
                                style={{
                                    color: theme.palette.primary.main,
                                    position: 'absolute',
                                    right: 8,
                                    top: 4,
                                    fontSize: '1rem'
                                }}
                                onClick={onRemove}
                            />
                        </Tooltip>
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            bottom: 0,
                            right: 0,
                            left: 0,
                            padding: '4px 8px 4px 8px',
                            background: 'rgba(255,255,255,0.9)'
                        }}
                    >
                        <h5>From {formatMoney(minRetailPrice)}</h5>
                        <h4>{activity.name}</h4>
                    </div>
                </CardMedia>
            </Card>
        </Grid>
    );
}

export default withTheme(ActivityCardForCompare);
